import axios from "axios";

const urlPath = "registroKae";

export const getRegistrosKae = async () => {
  try {
    const response = await axios.get(urlPath);
    return response.data;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const filterRegistrosKae = async (filtros) => {
  try {
    const response = await axios.post(`${urlPath}/filter`, filtros);
    return response.data;
  } catch (err) {
    console.log(err);
    return err;
  }
};
